import classNames from 'classnames'
import React from 'react'

interface Props {
  name: string
}

export const PrimaryNav: React.FC<Props> = ({ name, children }) => {
  return (
    <>
      <nav className={`stk-primary-nav`} aria-label={name}>
        {children}
      </nav>
    </>
  )
}

export const PrimaryNavList: React.FC = ({ children }) => {
  return (
    <>
      <ul className={`stk-primary-nav__list`}>{children}</ul>
    </>
  )
}

interface PrimaryNavItemProps {
  selected: boolean
}

export const PrimaryNavItem: React.FC<PrimaryNavItemProps> = ({
  selected,
  children,
}) => {
  const classes = classNames('stk-primary-nav__item', {
    'stk-primary-nav__item--selected': selected,
  })
  return (
    <>
      <li className={classes}>{children}</li>
    </>
  )
}

interface PrimaryNavLinkProps {
  href: string
  isDropdown?: boolean
}

export const PrimaryNavLink: React.FC<PrimaryNavLinkProps> = ({
  href,
  isDropdown = false,
  children,
}) => {
  return (
    <>
      <a
        href={href}
        className={classNames('stk-primary-nav__action', {
          'stk-primary-nav__action--dropdown': isDropdown,
        })}
      >
        {children}
      </a>
    </>
  )
}

interface PrimaryNavLabelProps {
  isDropdown?: boolean
}

export const PrimaryNavLabel: React.FC<PrimaryNavLabelProps> = ({
  isDropdown,
  children,
}) => {
  return (
    <>
      <span
        className={classNames('stk-primary-nav__action', {
          'stk-primary-nav__action--dropdown': isDropdown,
        })}
      >
        {children}
      </span>
    </>
  )
}
